import {
  Platform,
  Pressable,
  StatusBar,
  StyleSheet,
  Text,
  View,
} from "react-native";
import React, { useCallback, useState } from "react";
import { useNavigation } from "@react-navigation/native";
import DateTimePicker from "@react-native-community/datetimepicker";
import TopIconView from "../../../Auth/components/TopIconView";
import TextView from "../../../../components/CustomComponent/TextView";
import ProfileIcons from "../../../../assets/Icons/FeedIcons/ProfileIcons";
import GlobalStyles from "../../../../globalStyles/globalStyles";
import BottomView from "../../../../components/GlobalComponents/BottomView";
import AgeModal from "../../../../modal/OnBoardingModal/AgeModal";
import CustomComponent from "../../../../components/CustomComponent";
import { Colors } from "../../../../globalStyles/ColorConfig";
import { useBackButtonHandler } from "../../hooks/useBackHandler";
import { handleBackButton } from "../../components/BackButtonAlert";
import { calculateAge } from "../../../../utils/timeUtils";
import { SafeAreaView } from "react-native-safe-area-context";

const BasicInfo_DateOfBirth = () => {
  const navigation = useNavigation();
  useBackButtonHandler(handleBackButton, [navigation]);

  const [month, setMonth] = useState("MM");
  const [day, setDay] = useState("DD");
  const [year, setYear] = useState("YYYY");
  const [age, setAge] = useState(0);
  const [isModalVisible, setModalVisible] = useState(false);
  const [isDateModalVisible, setIsDateModalVisible] = useState(false);
  const [dateOfBirth, setDateOfBirth] = useState(new Date());
  const [isDOBValid, setIsDOBValid] = useState(false);
  const [isDOBSelected, setIsDOBSelected] = useState(false);

  const toggleModal = () => {
    setAge(calculateAge(`${year}-${month}-${day}`));
    setModalVisible(!isModalVisible);
  };

  const handleDOBModal = () => {
    setIsDateModalVisible(true);
  };

  const handleDOBChange = useCallback((selectedDate: any) => {
    if (selectedDate) {
      setDateOfBirth(selectedDate);
      setMonth((selectedDate.getUTCMonth() + 1).toString().padStart(2, "0"));
      setDay(selectedDate.getDate().toString().padStart(2, "0"));
      setYear(selectedDate.getFullYear().toString());
      const age = calculateAge(selectedDate);
      setIsDOBValid(age >= 18);
      setIsDOBSelected(true);
    }
  }, []);

  const handleDone = () => {
    setIsDateModalVisible(false);
    handleDOBChange(dateOfBirth);
  };
  

  const renderDatePicker = () => {
    if (isDateModalVisible) {
      return (
        <View
          style={{
            position: "absolute",
            bottom: 0,
            width: "100%",
            backgroundColor: "#ffffff",
            zIndex: 1,
          }}
        >
          {
            Platform.OS === 'ios' && (
              <View style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                paddingHorizontal: 40
              }}>
                <Text style={[GlobalStyles.bodyText,{color: Colors.gold10}]}>Select A Date</Text>
                <Pressable  onPress={handleDone}>
                  <Text style={[GlobalStyles.bodyTextBold,{color: Colors.gold10}]}>Done</Text>
                </Pressable>
              </View>
            )            
          }
          <DateTimePicker
            value={dateOfBirth}
            minimumDate={new Date(1980, 0, 1)}
            maximumDate={new Date()}
            display="spinner"
            mode="date"
            onChange={(event, selectedDate) => handleDOBChange(selectedDate)}
          />
        </View>
      );
    }
    return null;
  };
      
  const renderErrorMessage = () => {
    if (isDOBSelected && !isDOBValid) {
      return (
        <CustomComponent.TextView
          title={"Age should be 18 or above"}
          textStyle={[GlobalStyles.bodyText, { color: Colors.red10 }]}
        />
      );
    }
    return null;
  };

  const renderInput = (value: string) => {
    return (
      <CustomComponent.TextView
        title={value}
        textStyle={{ fontSize: 14 ,opacity: value !== "MM" && value !== "DD" && value !== "YYYY" ? 1 : 0.4 }}
      />
    );
  };

  return (
    <SafeAreaView style={styles.container}>
      <StatusBar barStyle="dark-content" backgroundColor={Colors.white000} />
      {renderDatePicker()}
      <AgeModal
        isVisible={isModalVisible}
        toggleModal={toggleModal}
        age={age}
        dob={[day, month, year]}
      />
      <View style={styles.mainContainer}>
        <TopIconView
          icon={<ProfileIcons.BirthdayIcon />}
          totalScreens={2}
          currentScreen={2}
        />
        <View>
          <TextView
            title="What's your date of birth?"
            textStyle={[
              GlobalStyles.heading3,
              {
                fontFamily: "EBGaramondSemiBold",
                fontSize: 34,
                lineHeight: 34,
                letterSpacing: -0.3,
              },
            ]}
          />
          <View style={styles.dateInputContainer}>
            <Pressable onPress={handleDOBModal}>
              <View style={styles.input}>
              {renderInput(month)}
              </View>
            </Pressable>
            <Pressable onPress={handleDOBModal}>
              <View style={styles.input}>
              {renderInput(day)}
              </View>
            </Pressable>
            <Pressable onPress={handleDOBModal}>
              <View style={[styles.input, { width: 80 }]}>
              {renderInput(year)}
              </View>
            </Pressable>
          </View>
          {renderErrorMessage()}
        </View>
      </View>
      <BottomView
        enableTitle={true}
        onPress={toggleModal}
        bottomTitle="We use this to calculate the age on your profile"
        bottomTitleIcon={false}
        disableBtn={isDOBValid}
        style={{paddingBottom: 20}}
      />
    </SafeAreaView>
  );
};

export default BasicInfo_DateOfBirth;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#ffffff",
    paddingTop: 30
  },
  mainContainer: {
    flex: 1,
    paddingHorizontal: 25,
    gap: 16
  },
  dateInputContainer: {
    flexDirection: "row",
    paddingVertical: 14,
  },
  input: {
    backgroundColor: "#F1F1F1",
    width: 60,
    height: 45,
    marginHorizontal: 5,
    textAlign: "center",
    borderRadius: 8,
    alignItems: "center",
    justifyContent: "center",
  },
});
